<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.techConfChanges') }}</h2>
      <el-table :data="tableData" border :header-cell-style="{backgroundColor: '#f0f0f0'}">
        <el-table-column prop="changeType" :label="$t('crm.logChangeType')"></el-table-column>
        <el-table-column prop="updateContent" :label="$t('crm.logChangeContent')"></el-table-column>
        <el-table-column :label="$t('crm.logChangeTime')">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.updateTime) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.visitRecord') }}</h2>
      <el-table :data="tableData2" border :header-cell-style="{backgroundColor: '#f0f0f0'}">
        <el-table-column prop="visitType" :label="$t('crm.logVisitType')"></el-table-column>
        <el-table-column :label="$t('crm.logVisitDate')">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.visitTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="visitPurpose" :label="$t('crm.logVisitPurpose')"></el-table-column>
        <el-table-column prop="agreement" :label="$t('crm.logComeToAgreement')"></el-table-column>
        <el-table-column prop="remark" :label="$t('crm.logRemark')"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import utils from '@/utils/util';
import {
  getLogRecordList,
  getBusinessVisit,
} from '../api';

export default {
  data() {
    return {
      tableData: [],
      tableData2: [],
    };
  },
  mounted() {
    getLogRecordList({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.tableData = res.data.data || [];
      }
    });
    getBusinessVisit({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.tableData2 = res.data.data || [];
      }
    });
  },
  methods: {
    dateFormat(time) {
      if (!time) {
        return '';
      }
      time = Number(time);
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
  }
}
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  &.full {
    width: 100%;
  }

  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n+3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }
}
</style>
